<template>
  <div class="Grid-twelve Grid-twelve--restaurant my-8" v-if="particularity">
    <ux-atoms-typo :text="particularity" as="h2" class="py-2" color="dark" variant="expressive-heading-04" />
  </div>
  <div :class="['Restaurant-anecdote-and-chef', { 'Restaurant-anecdote-and-chef__one-block': hasOnlyOneBlock }]" v-if="anecdote || chef">
    <ux-molecules-restaurant-anecdote-and-chef-block
      :description="anecdote?.description"
      :description-title="anecdote?.descriptionTitle"
      :image="anecdoteImage"
      v-if="anecdote"
    />
    <ux-molecules-restaurant-anecdote-and-chef-block
      :description="chef?.description"
      :description-title="chef?.descriptionTitle"
      :image="chefImage"
      v-if="chef"
    />
  </div>
</template>
<script lang="ts" setup>
import { Anecdote, RestaurantChef } from '~/graphql';

export interface RestaurantAnecdoteAndChef {
  anecdote?: Anecdote | null;
  chef?: RestaurantChef | null;
  particularity?: null | string;
}

const props = defineProps<RestaurantAnecdoteAndChef>();

const anecdoteImage = computed(() => {
  const images = props.anecdote?.medias?.filter((media) => !!media) || [];
  return images[0] ?? null;
});

const chefImage = computed(() => {
  const images = props.chef?.medias?.filter((media) => !!media) || [];
  return images[0] ?? null;
});

const hasOnlyOneBlock = computed(() => {
  return (props.anecdote && !props.chef) || (!props.anecdote && props.chef);
});
</script>
<style lang="scss" scoped>
@use 'RestaurantAnecdoteAndChef.scss';
</style>
